import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { DocumentService } from "../../../../services/document/document.service";
import { useMemo } from "react";
import _ from "lodash";
import { useSearchParams } from "../../../../hook/use-search-params";

export const useDocumentHistoryInfo = () => {
  const { id } = useParams<{ id: string }>();
  const { searchParams } = useSearchParams();
  const step = searchParams.get("step") || "new";

  const { data, isLoading } = useQuery<any[]>({
    queryKey: ["document-history-info", id],
    queryFn: () => DocumentService.getFileHistoryInfo(id),
  });

  const uniqueDocHisByStep = useMemo(() => {
    const docHisByStep = data?.filter((e: any) => e.fields.docStatusValue === step).map((e: any) => ({ ...e.fields }));
    return _.uniqBy(docHisByStep, "docPublicVersion");
  }, [data, step]);

  return { data, isLoading, uniqueDocHisByStep };
};
